module.exports = __webpack_public_path__ + "img/inbox_white_48dp.b812c9e8.svg";